import { z } from 'zod';
const optionalText = z.string().trim().max(500).optional().nullable();
export const branchInputSchema = z.object({
    code: z.string().trim().min(2, 'Kode minimal 2 karakter').max(32)
        .regex(/^[A-Za-z0-9-]+$/, 'Kode hanya boleh huruf, angka, dan tanda hubung'),
    name: z.string().trim().min(2, 'Nama minimal 2 karakter').max(200),
    address: optionalText,
    city: optionalText,
    province: optionalText,
    phone: z.string().trim().max(32).optional().nullable(),
    latitude: z.coerce.number().min(-90).max(90).optional().nullable(),
    longitude: z.coerce.number().min(-180).max(180).optional().nullable(),
    isActive: z.boolean().optional(),
});
export const branchUpdateSchema = branchInputSchema.partial();
export const hospitalInputSchema = z.object({
    code: z.string().trim().min(2, 'Kode minimal 2 karakter').max(32)
        .regex(/^[A-Za-z0-9-]+$/, 'Kode hanya boleh huruf, angka, dan tanda hubung'),
    name: z.string().trim().min(2, 'Nama minimal 2 karakter').max(200),
    address: optionalText,
    city: optionalText,
    province: optionalText,
    phone: z.string().trim().max(32).optional().nullable(),
    email: z.string().trim().toLowerCase().email('Format email tidak valid').optional().nullable(),
    isActive: z.boolean().optional(),
});
export const hospitalUpdateSchema = hospitalInputSchema.partial();
/**
 * One page of a master-data table. Ten rows is what the tables are built for, so it is
 * the default here rather than a number every caller has to remember.
 *
 * The cap stays well above the default because a few callers are not tables at all:
 * a `<select>` of branches or hospitals needs the whole short list in one request. Those
 * pass an explicit `pageSize`; anything that forgets gets a page, not a table dump.
 */
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;
export const listQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    q: z.string().trim().max(200).optional(),
    includeInactive: z.coerce.boolean().default(false),
});
